import { combineReducers } from 'redux'

import deleteNode from './batteries/delete'
import get from './batteries/get'
import list from './batteries/list'
import post from './batteries/post'
import put from './batteries/put'

export default combineReducers({
  delete: deleteNode,
  get,
  list,
  post,
  put
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/batteries.js